export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14737.e464288e.jpg";